export default __webpack_public_path__ + "static/media/icon_checkbox_on.b58359f3.svg";